import { Reveal, SectionHead } from "@/components/Shared";

const ENGAGEMENTS = [
  {
    id: "ihub-gujarat",
    index: "01",
    entity: "i-Hub Gujarat",
    tag: "Institutional MoU · Government of Gujarat · 2025",
    challenge:
      "A state-backed startup hub needed its portfolio ventures to move beyond ideation, into markets, institutional capital and real capacity.",
    mandate:
      "A two-year strategic MoU to guide startups through the mind-to-market journey: structured mentorship, investor connections and capacity-building programs across the i-Hub ecosystem.",
    outcome:
      "BYOT's incubation framework and investor network now sit inside one of India's most active state innovation missions, with portfolio ventures gaining a direct line to capital and counsel.",
  },
  {
    id: "meity-mandate",
    index: "02",
    entity: "Ministry of Electronics & IT",
    tag: "Public-Sector Mandate · Government of India",
    challenge:
      "National deep-tech programs demanded translation between policy ambition and executable technology delivery, at mission scale.",
    mandate:
      "Technical Officer tenure inside MeitY: program design, technology evaluation and delivery across the Government of India's electronics and IT initiatives.",
    outcome:
      "Insider fluency in how national missions are built, evaluated and funded, now applied to every BYOT B2G engagement, so clients never guess how the state decides.",
  },
  {
    id: "private-analytics",
    index: "03",
    entity: "Varahe Analytics",
    tag: "Private-Sector Mandate · Analytics & Strategy",
    challenge:
      "High-stakes private engagements needed decision-grade analytics under unforgiving timelines, where a wrong read costs crores.",
    mandate:
      "Analytics consulting across large-scale engagements: data strategy, insight architecture and execution discipline for private-sector outcomes.",
    outcome:
      "The private-sector counterweight to BYOT's institutional depth, speed, measurement and outcomes built to survive boardroom scrutiny.",
  },
];

export default function Engagements() {
  return (
    <section id="engagements" data-testid="engagements-section" className="mx-auto max-w-7xl px-5 py-24 sm:px-8 md:py-32">
      <SectionHead
        overline="Selected Engagements"
        title={<>Proof over <em className="gold-text not-italic">promises.</em></>}
        testId="engagements-heading"
      />
      <div className="flex flex-col gap-4">
        {ENGAGEMENTS.map((e, i) => (
          <Reveal key={e.id} delay={i * 0.08}>
            <article
              data-testid={`engagement-card-${e.id}`}
              className="group grid gap-8 border border-[rgba(212,175,55,0.18)] bg-[#0F1A2E]/70 p-7 transition-colors duration-500 hover:border-[#D4AF37]/55 hover:bg-[#16243E] sm:p-10 lg:grid-cols-[auto_1fr] lg:gap-14"
            >
              <div className="flex items-start gap-5 lg:w-64 lg:flex-col lg:gap-4">
                <div>
                  <h3 className="font-serif text-2xl text-[#F7F5F0]">{e.entity}</h3>
                  <p className="mt-2 font-mono-alt text-[10px] uppercase leading-relaxed tracking-[0.22em] text-[#D4AF37]">
                    {e.tag}
                  </p>
                </div>
              </div>
              <div className="grid gap-6 sm:grid-cols-3 sm:gap-8">
                {[
                  ["Challenge", e.challenge, `engagement-${e.id}-challenge`],
                  ["Mandate", e.mandate, `engagement-${e.id}-mandate`],
                  ["Outcome", e.outcome, `engagement-${e.id}-outcome`],
                ].map(([label, text, testId]) => (
                  <div key={label} data-testid={testId} className="border-t border-[rgba(212,175,55,0.25)] pt-4">
                    <p className="font-mono-alt text-[10px] uppercase tracking-[0.28em] text-[#94A3B8]">{label}</p>
                    <p className="mt-3 text-sm leading-relaxed text-[#CBD5E1]">{text}</p>
                  </div>
                ))}
              </div>
            </article>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
